import { useAppSelector } from '@store';
import {
  ButtonPrimary,
  IconLoader,
  PermissionDenied,
  PermissionEnum,
} from '@ui/src';
import useFintracSettings from './hooks/use-fintrac-settings';
import FintracReportSettingsForm from '../../../../components/reports-settings/fintrac/fintrac';

import cn from '../styles.module.css';

const FintracReportSettings = () => {
  const { activePermissions, currencies } = useAppSelector(
    (state) => state.root,
  );
  const { fintracReportSettings } = useAppSelector(
    (state) => state.reportsSettings,
  );

  const {
    isLoading,
    isFetching,
    control,
    errors,
    onSubmit,
    requestInProgress,
    globalError,
    thresholdCurrencyId,
  } = useFintracSettings({ activePermissions, fintracReportSettings });

  let content;

  if (
    !activePermissions?.includes(
      PermissionEnum.SETTINGS_REGULATORY_REPORT_FINTRAC_EDIT_ACTION,
    )
  ) {
    content = <PermissionDenied />;
  } else if (
    activePermissions?.includes(
      PermissionEnum.SETTINGS_REGULATORY_REPORT_FINTRAC_EDIT_ACTION,
    )
  ) {
    if (isLoading || isFetching) {
      content = (
        <div className={cn.fintracReportSettingsLoader}>
          <IconLoader />
        </div>
      );
    } else {
      content = (
        <div className={cn.fintracReportSettingsFormWrapper}>
          <FintracReportSettingsForm
            control={control}
            errors={errors}
            currencies={currencies}
            thresholdCurrencyId={thresholdCurrencyId}
          />
          <div className={cn.fintracReportsSettingsControl}>
            <ButtonPrimary
              text={requestInProgress ? 'Loading...' : 'Save'}
              onClick={onSubmit}
              disabled={requestInProgress}
              bold
            />
            {globalError && <div className={cn.globalError}>{globalError}</div>}
          </div>
        </div>
      );
    }
  }

  return (
    <div className={cn.fintracReportSettings}>
      <div className={cn.fintracReportSettingsTitle}>External Reports</div>
      {content}
    </div>
  );
};

export default FintracReportSettings;
